<template>
    <v-progress-circular indeterminate color="#8e84c0" size="60" width="3" class="loading-spinner">
        <v-img :src="Logo" height="33px" width="33px">
        </v-img>
    </v-progress-circular>
</template>

<script>
import Logo from '@/assets/logo/1-10.webp';
export default {
    name: 'HarmonyLoader',
    data() {
        return {
            Logo
        };
    }
}
</script>


<style scoped>
.loading-spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
}
</style>